<template>
    <div class="row">
        <!-- KGVM Değerler Start -->
        <div class="col-12 mb-1">
            <label class="form-label">KGVM 1 Değer</label>
            <v-validator :errors="errors" parameter="KGVM_1_Deger" :watch="value.KGVM_1_Deger">
                <input type="number" v-model="value.KGVM_1_Deger" class="form-control" placeholder="KGVM 1 Değer"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">KGVM 2 Değer</label>
            <v-validator :errors="errors" parameter="KGVM_2_Deger" :watch="value.KGVM_2_Deger">
                <input type="number" v-model="value.KGVM_2_Deger" class="form-control" placeholder="KGVM 2 Değer"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">KGVM 3 Değer</label>
            <v-validator :errors="errors" parameter="KGVM_3_Deger" :watch="value.KGVM_3_Deger">
                <input type="number" v-model="value.KGVM_3_Deger" class="form-control" placeholder="KGVM 3 Değer"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">KGVM 4 Değer</label>
            <v-validator :errors="errors" parameter="KGVM_4_Deger" :watch="value.KGVM_4_Deger">
                <input type="number" v-model="value.KGVM_4_Deger" class="form-control" placeholder="KGVM 4 Değer"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">KGVM 5 Değer</label>
            <v-validator :errors="errors" parameter="KGVM_5_Deger" :watch="value.KGVM_5_Deger">
                <input type="number" v-model="value.KGVM_5_Deger" class="form-control" placeholder="KGVM 5 Değer"/>
            </v-validator>
        </div>
         <!-- KGVM Değerler End -->

         <!-- KGVM Oranlar Start -->
         <div class="col-12 mb-1">
            <label class="form-label">KGVM 1 Oran</label>
            <v-validator :errors="errors" parameter="KGVM_1_Oran" :watch="value.KGVM_1_Oran">
                <input type="number" v-model="value.KGVM_1_Oran" class="form-control" placeholder="KGVM 1 Oran"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">KGVM 1 Oran</label>
            <v-validator :errors="errors" parameter="KGVM_2_Oran" :watch="value.KGVM_1_Oran">
                <input type="number" v-model="value.KGVM_2_Oran" class="form-control" placeholder="KGVM 2 Oran"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">KGVM 1 Oran</label>
            <v-validator :errors="errors" parameter="KGVM_3_Oran" :watch="value.KGVM_3_Oran">
                <input type="number" v-model="value.KGVM_3_Oran" class="form-control" placeholder="KGVM 3 Oran"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">KGVM 1 Oran</label>
            <v-validator :errors="errors" parameter="KGVM_4_Oran" :watch="value.KGVM_4_Oran">
                <input type="number" v-model="value.KGVM_4_Oran" class="form-control" placeholder="KGVM 4 Oran"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">KGVM 1 Oran</label>
            <v-validator :errors="errors" parameter="KGVM_5_Oran" :watch="value.KGVM_5_Oran">
                <input type="number" v-model="value.KGVM_5_Oran" class="form-control" placeholder="KGVM 5 Oran"/>
            </v-validator>
        </div>
        <!-- KGVM Oranlar End -->
         
        <!-- Other Start -->
        <div class="col-12 mb-1">
            <label class="form-label">SGKIsciOran</label>
            <v-validator :errors="errors" parameter="SGKIsciOran" :watch="value.SGKIsciOran">
                <input type="number" v-model="value.SGKIsciOran" class="form-control" placeholder="SGKIsciOran"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">SGKIsciKontrolDegeri</label>
            <v-validator :errors="errors" parameter="SGKIsciKontrolDegeri" :watch="value.SGKIsciKontrolDegeri">
                <input type="number" v-model="value.SGKIsciKontrolDegeri" class="form-control" placeholder="SGKIsciKontrolDegeri"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">IssizlikIsciOran</label>
            <v-validator :errors="errors" parameter="IssizlikIsciOran" :watch="value.IssizlikIsciOran">
                <input type="number" v-model="value.IssizlikIsciOran" class="form-control" placeholder="IssizlikIsciOran"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">IssizlikIsciKontrolDegeri</label>
            <v-validator :errors="errors" parameter="IssizlikIsciKontrolDegeri" :watch="value.IssizlikIsciKontrolDegeri">
                <input type="number" v-model="value.IssizlikIsciKontrolDegeri" class="form-control" placeholder="IssizlikIsciKontrolDegeri"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">GVIstisnasi</label>
            <v-validator :errors="errors" parameter="GVIstisnasi" :watch="value.GVIstisnasi">
                <input type="number" v-model="value.GVIstisnasi" class="form-control" placeholder="GVIstisnasi"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">DamgaVergisiDegeri</label>
            <v-validator :errors="errors" parameter="DamgaVergisiDegeri" :watch="value.DamgaVergisiDegeri">
                <input type="number" v-model="value.DamgaVergisiDegeri" class="form-control" placeholder="DamgaVergisiDegeri"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">DamgaVergisiOrani</label>
            <v-validator :errors="errors" parameter="DamgaVergisiOrani" :watch="value.DamgaVergisiOrani">
                <input type="number" v-model="value.DamgaVergisiOrani" class="form-control" placeholder="DamgaVergisiOrani"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">SGKIsverenDeger</label>
            <v-validator :errors="errors" parameter="SGKIsverenDeger" :watch="value.SGKIsverenDeger">
                <input type="number" v-model="value.SGKIsverenDeger" class="form-control" placeholder="SGKIsverenDeger"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">SGKIsverenOran</label>
            <v-validator :errors="errors" parameter="SGKIsverenOran" :watch="value.SGKIsverenOran">
                <input type="number" v-model="value.SGKIsverenOran" class="form-control" placeholder="SGKIsverenOran"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">IsverenIssizlikDeger</label>
            <v-validator :errors="errors" parameter="IsverenIssizlikDeger" :watch="value.IsverenIssizlikDeger">
                <input type="number" v-model="value.IsverenIssizlikDeger" class="form-control" placeholder="IsverenIssizlikDeger"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">IsverenIsslizlikOran</label>
            <v-validator :errors="errors" parameter="IsverenIsslizlikOran" :watch="value.IsverenIsslizlikOran">
                <input type="number" v-model="value.IsverenIsslizlikOran" class="form-control" placeholder="IsverenIsslizlikOran"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="from-label">StartDate</label>
            <v-validator :errors="errors" parameter="Date" :watch="value.StartDate">
                <v-date-picker v-model="value.StartDate" placeholder="StartDate"></v-date-picker>
            </v-validator>
        </div>

         
        <!-- Other  End -->

    </div>
</template>

<script>
export default {
    props:{
        value:Object,
        errors:Object
    }
}
</script>

<style>

</style>